import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";

declare var ko: any;

export class websiteMenuList_template extends vnTemplate {

    protected resultInfos: resultsInfo_template;
    protected pagination: pagination_template;

    protected initPartial() {
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller)
        this.pagination.getTemplateViewModel().itemPerPage = 10;

    }

    protected buildViewModel(): any {
        let huit_neuf_this = this;
        return {
            menus : ko.observableArray([]),
            onClickView : function (data, event) {
                huit_neuf_this.onClickView(data.id)
            }
        }
    }

    protected getTemplateHtml(): string {
        return (

            ` <div class="w-list-results" id="list-results">
                <table class="list-results">
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none">Name</span></th>
                            <th><span class="icon list-sort-none">Created On</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: menus">
    
                        <tr  class="cursor">
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiEdit }"><span data-bind="text: name"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiEdit }"><span data-bind="text: dateCreated"></span></a></td>
                        </tr>
                        
                    </tbody>
                </table>
            </div>   `

        );
    }

    protected getTemplateName(): string {
        return "websiteMenuList_template";
    }


    public setMenu(menusObj, brandId){
        let menus = []
        for (let m of menusObj){
            menus.push({
                id: m.id,
                name: m.name,
                emakiEdit: '/brand/' + brandId + '/config/menu/edit/' + m.id,
                dateCreated: m.dateCreated
            })
        }
        this.getTemplateViewModel().menus(menus)
    }

    public onClickView(id) {

        this.caller.viewMenuItems(id);
    }

}


// WEBPACK FOOTER //
// ./js/components/templates/websiteMenuList_template.ts